import considerationsService from '../../services/voucher/considerations-service';

import {
  FETCH_CONSIDERATIONS_BY_DEAL_ID_SUCCESS,
  FETCH_VOUCHER_OPTIONS_SUCCESS,
  CREATE_CONSIDERATION_SUCCESS,
  DELETE_CONSIDERATION_SUCCESS,
  UPDATE_CONSIDERATION_SUCCESS,
  UPDATE_CONSIDERATION_STATE,
} from './action-types';
import { updateFinancials, updateLoadedFinancials, FINANCIAL_TYPES } from './financial-actions';
import { selectTotalCommissions } from '../selectors/voucher-selectors';
import REQUEST_STATE from '../../utils/request-state';

// action creators
const fetchLeaseConsiderationTypeOptionsSuccess = options => ({
  type: FETCH_VOUCHER_OPTIONS_SUCCESS,
  payload: { leaseConsiderationTypeOptions: options },
});

const fetchConsiderationsSuccess = considerations => ({
  type: FETCH_CONSIDERATIONS_BY_DEAL_ID_SUCCESS,
  payload: considerations,
});

const createConsiderationSuccess = consideration => ({
  type: CREATE_CONSIDERATION_SUCCESS,
  payload: consideration,
});

const deleteConsiderationSuccess = id => ({
  type: DELETE_CONSIDERATION_SUCCESS,
  payload: id,
});

const updateConsiderationSuccess = consideration => ({
  type: UPDATE_CONSIDERATION_SUCCESS,
  payload: consideration,
});

const updateConsiderationState = state => ({
  type: UPDATE_CONSIDERATION_STATE,
  payload: state,
});


// dispatch
const fetchLeaseConsiderationTypeOptions = () => dispatch =>
  considerationsService.fetchLeaseConsiderationTypeOptions()
    .then(options => dispatch(fetchLeaseConsiderationTypeOptionsSuccess(options)))
    .catch(error => console.error('Error fetching lease consideration type options'));

const createConsideration = post => dispatch =>
  considerationsService.createConsideration(post)
    .then(res => dispatch(createConsiderationSuccess(res)))
    .catch(error => console.error('Error creating considerations'));

const updateConsiderationInState = (id, patch) => (dispatch, getState) => {
  const currentConsideration = getState().voucherConsiderations.considerations
    .find(consideration => consideration.id === id);
  if (!currentConsideration) return;
  dispatch(updateConsiderationSuccess({ ...currentConsideration, ...patch }));
};

const deleteConsideration = (id, options = {}) => (dispatch, getState) => {
  const dealId = getState().deal.deal.id;
  const previousTotal = selectTotalCommissions(getState());

  return considerationsService.deleteConsideration(id)
    .then(() => {
      dispatch(deleteConsiderationSuccess(id));
      if (options.updateLoadedFinancialsOnly) {
        dispatch(updateLoadedFinancials(dealId, FINANCIAL_TYPES.CONSIDERATION, previousTotal));
      } else if (!options.skipFinancialFanout) {
        dispatch(updateFinancials(dealId, FINANCIAL_TYPES.CONSIDERATION));
      }
    })
    .catch((error) => {
      console.error('Error deleting consideration');
      throw error;
    });
};

const updateConsideration = (id, patch, options = {}) => (dispatch, getState) => {
  const previousTotal = selectTotalCommissions(getState());

  return (
  considerationsService.patchConsideration(id, patch)
    .then((res) => {
      dispatch(updateConsiderationSuccess(res));
      if ('commission_amount' in patch || 'commission_percent' in patch) {
        if (options.updateLoadedFinancialsOnly) {
          dispatch(updateLoadedFinancials(res.transaction, FINANCIAL_TYPES.CONSIDERATION, previousTotal, { force: true }));
        } else if (!options.skipFinancialFanout) {
          dispatch(updateFinancials(res.transaction, FINANCIAL_TYPES.CONSIDERATION));
        }
      }
    })
    .catch(error => console.error('Error updating consideration'))
  );
};

const fetchConsiderations = dealId => (dispatch) => {
  dispatch(updateConsiderationState(REQUEST_STATE.LOADING));
  return considerationsService.fetchConsiderations(dealId)
    .then(considerations => dispatch(fetchConsiderationsSuccess(considerations)))
    .catch(error => console.error('Error fetching considerations'))
    .finally(() => dispatch(updateConsiderationState(REQUEST_STATE.NONE)));
};

export {
  createConsideration,
  deleteConsideration,
  fetchConsiderations,
  updateConsideration,
  updateConsiderationInState,
  fetchLeaseConsiderationTypeOptions,
};
